import React, { Component, createRef } from "react";
// import OnboardingSidebar from "./OnboardingSidebar"; // replaced by top bar
import OnboardingTopBar from "./OnboardingTopBar";
import OnboardingContent from "./OnboardingContent";
import ClientHeader from "../../../components/Client/Header";
// import ClientFooter from "../../../components/Client/footer";
import TextField from "../../../components/InputFields/TextField";
import PasswordStrengthBar from "react-password-strength-bar";
import { Tooltip } from "@material-ui/core";
import Select from "react-select";
import HelperClass from "../../../config/helperClass";
import {
  clientLeftMenu,
  profileUpdate as clientProfileUpdate,
  getClientPermissionData,
  save_onboarding_for_specific_user,
} from "../../../config/client_api_calls";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { PhoneNumberUtil } from "google-libphonenumber";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneInput } from "react-international-phone";

import MutextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

const ValidateEmail = (mail) => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
    return true;
  }
  return false;
};

class OnboardingDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      stepsData: [], // Store all steps data from API
      userType: "client", // Dedicated Client component
      clientAccountNo: "", // Account number for API calls
      formToken: "", // Current step's form token
      form: {}, // Current step's form object
      formAccountNo: "", // Form account number (form ID from API steps)
      allowSkip: 0, // Whether current step allows skip
      stepTitle: "", // Current step's title
      // Profile form state
      comp_name: "",
      name: "",
      title: "",
      email: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      states: "",
      zip: "",
      country: "United States",
      password: "",
      confirm_password: "",
      passwordShown: false,
      confirmPasswordShown: false,
      disabled: false,
      errorMessage: "",
      successMessage: "",
      // Error states
      errorCompName: "",
      errorName: "",
      errorTitle: "",
      errorEmail: "",
      errorPhone: "",
      errorAddress: "",
      errorAddress2: "",
      errorCity: "",
      errorState: "",
      errorZip: "",
      errorCountry: "",
      errorPass: "",
      errorConfirmPass: "",
      // Login details
      loginDetails: [],
      // Additional data for profile update
      is_msa_signed: false,
      clientData: [],
      integrationInfo: [],
      parentIntegration: [],
      voicePermissionAdmin: "",
      // Address autocomplete settings
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      address_autocomplete: true,
      address_validation: true,
      // Track submitted steps for review-only mode
      submittedSteps: new Set(), // Steps that have been submitted
      isFormInReviewMode: false, // Flag to indicate current step is in review mode
      skipSuccessMessage: "", // Success message when skipping last step
      // Mobile responsive state
      isMobile: window.innerWidth <= 768,
      isMobileSidebarOpen: false,
      // Onboarding title/message from API
      onboardingTitle: "",
      onboardingMessage: "",
    };
    this.phoneInputRef = createRef();
    this.sidebarRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      );
  }

  componentDidMount() {
    // Client-specific setup
    const userType = "client";
    const clientAccountNo = auth.getClientAccount();

    this.setState({ userType, clientAccountNo }, async () => {
      this.loadProfileData();
      await this.getClientPermissionData();
      await this.loadLoginDetails();
    });

    // Add resize listener for mobile detection
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    // Clean up resize listener
    window.removeEventListener("resize", this.handleWindowResize);
  }

  handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState((prevState) => {
      // Auto-close sidebar when resizing to desktop
      if (!isMobile && prevState.isMobileSidebarOpen) {
        return { isMobile, isMobileSidebarOpen: false };
      }
      return { isMobile };
    });
  };

  handleToggleMobileSidebar = () => {
    this.setState((prevState) => ({
      isMobileSidebarOpen: !prevState.isMobileSidebarOpen,
    }));
  };

  loadProfileData = async () => {
    // Client-specific profile loading
    this.setState({
      comp_name: auth.getCompNameClient() || "",
      name: auth.getNameClient() || "",
      email: auth.getEmailClient() || "",
      phone: auth.getPhoneClient() || "",
      title: auth.getTitleClient() || "",
    });
  };

  getClientPermissionData = async () => {
    // CLIENT PERMISSION DATA LOADING
    try {
      const acctno = auth.getClientAccount();
      const token = auth.getClientToken();

      const res = await getClientPermissionData(acctno, token);

      if (res.data.status === 200 && res.data.message === "success") {
        const permissionData =
          res.data.clientPermissionSettingsInfo?.data || {};
        this.setState({
          clientData: res.data.clientData || [],
          integrationInfo: res.data.integrationInfo || [],
          parentIntegration: res.data.parentIntegration || [],
          voicePermissionAdmin: res.data.voicePermissionAdmin || "",
          address_autocomplete: permissionData.address_autocomplete,
          address_validation: permissionData.address_validation,
        });
      } else if (
        res.data.status === 403 ||
        res.data.errors === "authentication missing" ||
        res.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      }
    } catch (error) {
      console.error("Error loading client permission data:", error);
    }
  };

  loadLoginDetails = async () => {
    // CLIENT LOGIN DETAILS LOADING
    try {
      const accountNo = auth.getClientAccount();
      const token = auth.getClientToken();
      const email = auth.getEmailClient();

      if (!accountNo || !token || !email) {
        console.warn("Missing required authentication data");
        this.setState({ loginDetails: [] });
        return;
      }

      const res = await clientLeftMenu(accountNo, token, email);

      if (
        res.data.status === 200 &&
        res.data.message === "success" &&
        res.data.loginDetails
      ) {
        this.setState({ loginDetails: res.data.loginDetails || [] });
      } else if (
        res.data.status === 403 ||
        res.data.errors === "authentication missing" ||
        res.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else {
        this.setState({ loginDetails: [] });
      }
    } catch (error) {
      console.error("Error loading login details:", error);
      this.setState({ loginDetails: [] });
    }
  };

  handleStepChange = (step) => {
    this.setState({ currentStep: step });
  };

  handleFormTokenChange = (formToken) => {
    // Receive formToken from sidebar when step changes
    this.setState({ formToken: formToken });
  };

  handleFormChange = (form) => {
    // Receive form object from sidebar when step changes
    this.setState({ form: form });
  };

  handleFormAccountChange = (formAccountNo) => {
    // Receive form account number from sidebar when step changes
    this.setState({ formAccountNo: formAccountNo });
  };

  handleAllowSkipChange = (allowSkip) => {
    // Receive allowSkip flag from sidebar when step changes
    this.setState({ allowSkip: allowSkip });
  };

  handleStepTitleChange = (stepTitle) => {
    // Receive step title from sidebar when step changes
    this.setState({ stepTitle: stepTitle });
  };

  handleOnboardingTitleChange = (title, message) => {
    // Receive onboarding title and message from sidebar
    this.setState({
      onboardingTitle: title || "",
      onboardingMessage: message || "",
    });
  };

  handleSkipStep = async () => {
    // Called when user clicks skip button
    const {
      currentStep,
      stepsData,
      clientAccountNo,
      formToken,
      formAccountNo,
      stepTitle,
    } = this.state;

    // console.log("🔵 handleSkipStep called. Current step:", currentStep);
    // console.log("📊 StepsData:", stepsData);
    // console.log("⏸️ Is last step?", this.isLastStep());

    // Check if this is the last step
    if (this.isLastStep()) {
      // console.log("🏁 Skipping last step - calling onboarding API");
      try {
        const title = stepTitle;
        const form_accountno = formAccountNo;
        const isSkipped = 1;

        const response = await save_onboarding_for_specific_user(
          clientAccountNo,
          "client",
          title,
          formToken,
          form_accountno,
          isSkipped,
        );

        if (
          response &&
          (response.status === 200 ||
            response.data?.status === 200 ||
            response.data?.message === "success")
        ) {
          // console.log("✅ Last step skipped successfully!");
          // console.log("📊 Response data:", response.data);

          // Check if onboarding_status is "complete"
          const onboardingStatus =
            response.data?.onboarding_status ||
            response.data?.data?.onboarding_status;
          // console.log("📋 Onboarding Status:", onboardingStatus);

          // Set success message in state so it can be passed to OnboardingContent
          this.setState({
            skipSuccessMessage:
              '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Onboarding Steps Completed successfully.</div>',
          });

          // Scroll to top to show message
          window.scrollTo({ top: 0, behavior: "smooth" });

          // Reload page after 2 seconds (or immediately if onboarding_status is complete)
          const reloadDelay = onboardingStatus === "complete" ? 2000 : 2000;
          setTimeout(() => {
            // console.log("🔄 Reloading page...");
            window.location.reload();
          }, reloadDelay);
        }
      } catch (error) {
        console.error("❌ Error skipping last step:", error);
      }
      return; // Don't navigate further on last step
    }

    // Find the next enabled step
    let nextStep = currentStep + 1;
    while (nextStep < stepsData.length && stepsData[nextStep].isEnabled !== 1) {
      nextStep++;
    }

    // console.log("➡️ Next step calculated:", nextStep);

    // If there's a next step, navigate to it
    if (nextStep < stepsData.length) {
      const currentStepData = stepsData[currentStep];
      const nextStepData = stepsData[nextStep];

      // console.log("✅ Moving to next step:", nextStep, nextStepData);

      // Call API to save the skipped step
      try {
        const title = stepTitle;
        const form_accountno = formAccountNo;
        const isSkipped = 1;

        // console.log("📤 Calling save_onboarding_for_specific_user API with:", {
        //   accountno: clientAccountNo,
        //   type: "client",
        //   title,
        //   formToken,
        //   form_accountno,
        //   isSkipped,
        // });

        const response = await save_onboarding_for_specific_user(
          clientAccountNo,
          "client",
          title,
          formToken,
          form_accountno,
          isSkipped,
        );

        // console.log("✅ API Response:", response);

        if (response && response.status === 200) {
          // Mark current step as filled/skipped
          const updatedStepsData = [...stepsData];
          updatedStepsData[currentStep].isFilled = 1;
          updatedStepsData[currentStep].isSkipped = 1;

          // Update state with both current step and steps data
          this.setState({
            currentStep: nextStep,
            stepsData: updatedStepsData,
          });

          // Trigger all the form callbacks like the sidebar does when a step is clicked
          setTimeout(() => {
            // Get step title - try multiple property names
            const nextStepTitle =
              nextStepData.stepTitle ||
              nextStepData.name ||
              nextStepData.title ||
              nextStepData.step_title ||
              "";

            this.handleFormTokenChange(nextStepData.formToken || "");
            this.handleFormChange(nextStepData.form || {});
            this.handleFormAccountChange(nextStepData.form || "");
            this.handleAllowSkipChange(nextStepData.allowSkip || 0);
            this.handleStepTitleChange(nextStepTitle);
            // console.log(
            //   "✅ All callbacks triggered for step:",
            //   nextStep,
            //   "Title:",
            //   nextStepTitle
            // );
          }, 0);
        } else {
          console.error("❌ API returned error:", response);
        }
      } catch (error) {
        console.error("❌ Error calling skip API:", error);
      }
    }
    // else {
    // console.log("⚠️ No next step available");
    // }
  };

  // Helper function to check if current step is the last step
  isLastStep = () => {
    const { currentStep, stepsData } = this.state;
    return (
      stepsData && stepsData.length > 0 && currentStep === stepsData.length - 1
    );
  };

  handleStepsDataReceived = (stepsData) => {
    // Receive stepsData from sidebar when it's loaded
    this.setState({ stepsData: stepsData });
  };

  handleStepComplete = () => {
    // Called when form in a step is successfully submitted
    // console.log("✅ Step completed!");
    const { currentStep, stepsData, submittedSteps } = this.state;

    // Add current step to submitted steps set
    const newSubmittedSteps = new Set(submittedSteps);
    newSubmittedSteps.add(currentStep);
    this.setState({ submittedSteps: newSubmittedSteps });

    // Mark current step as filled
    if (stepsData && stepsData[currentStep]) {
      stepsData[currentStep].isFilled = 1;
      this.setState({ stepsData });
    }

    // Immediately mark step as completed in sidebar to show green tick without delay
    if (this.sidebarRef.current && this.sidebarRef.current.markStepCompleted) {
      this.sidebarRef.current.markStepCompleted(currentStep);
    }

    // Move to next step automatically (if not last step)
    const nextStep = currentStep + 1;
    if (stepsData && nextStep < stepsData.length) {
      const nextStepData = stepsData[nextStep];

      // Update all state and trigger callbacks for next step
      this.setState({ currentStep: nextStep }, () => {
        // Trigger all the form callbacks like the sidebar does
        if (nextStepData) {
          const nextStepTitle =
            nextStepData.stepTitle ||
            nextStepData.name ||
            nextStepData.title ||
            nextStepData.step_title ||
            "";

          this.handleFormTokenChange(nextStepData.formToken || "");
          this.handleFormChange(nextStepData.form || {});
          this.handleFormAccountChange(nextStepData.form || "");
          this.handleAllowSkipChange(nextStepData.allowSkip || 0);
          this.handleStepTitleChange(nextStepTitle);

          // console.log(
          //   "✅ All callbacks triggered for next step:",
          //   nextStep,
          //   "Title:",
          //   nextStepTitle
          // );
        }
      });
    } else if (this.isLastStep()) {
      // On last step: just mark as complete, don't navigate further
      // console.log("✅ Last step completed! All onboarding steps finished.");
    }
  };

  // Check if current step is already submitted (should be in review mode)
  isFormInReviewMode = () => {
    const { currentStep, submittedSteps } = this.state;
    return submittedSteps.has(currentStep);
  };

  profileView = () => {
    this.setState({ successMessage: "", errorMessage: "", password: "" });
    window.$("#modalFormProfile").modal("show");
  };

  loginDetailView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalLoginDetail").modal("show");
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        this.setState({
          city: city && city !== "" ? city : "",
          states: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "comp_name") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleChangeCountry = (event) => {
    this.setState({ country: event.label });
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  formUpdate = async () => {
    let {
      name,
      email,
      comp_name,
      title,
      phone,
      address,
      city,
      states,
      zip,
      password,
      confirm_password,
      is_msa_signed,
      address2,
      country,
      userType,
    } = this.state;

    const modalBody = document.getElementById("modalFormProfile");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    let is_validated = true;

    if (comp_name === "") {
      this.setState({
        errorCompName: "error",
        errorMessage: "Company Name is required.",
      });
      is_validated = false;
    } else if (name === "") {
      this.setState({
        errorCompName: "",
        errorName: "error",
        errorMessage: "Full Name is required.",
      });
      is_validated = false;
    } else if (phone === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(phone)) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (address === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (city === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (states === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (zip === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "error",
        errorMessage: "Zip is required.",
      });
      is_validated = false;
    } else if (country === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(email) === false) {
      this.setState({
        errorEmail: "error",
        errorName: "",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (password !== "") {
      if (password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(password)) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (confirm_password === "") {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (confirm_password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (password.trim() != confirm_password.trim()) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }

    if (is_validated) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "",
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        errorConfirm: "",
        errorPhone: "",
        errorTitle: "",
        disabled: true,
      });

      let apiResponse;

      // CLIENT PROFILE UPDATE - uses client API
      apiResponse = await clientProfileUpdate(
        auth.getClientAccount(),
        auth.getClientToken(),
        name,
        title,
        comp_name,
        phone,
        address,
        city,
        states,
        zip,
        password,
        address2,
        country,
      );

      if (
        apiResponse.data.status === 403 ||
        apiResponse.data.errors === "authentication missing" ||
        apiResponse.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (
        apiResponse.data.status === 409 &&
        apiResponse.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponse.data.errors
          ? String(apiResponse.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          disabled: false,
        });
      } else if (
        apiResponse.data.status === 200 &&
        apiResponse.data.message === "success"
      ) {
        // CLIENT COOKIE UPDATES
        Cookies.set(
          "client_comp_nme__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["comp_name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_name__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_phone__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["phone"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_title__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["title"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        this.setState({
          successMessage: "Profile updated successfully.",
          disabled: false,
        });

        if (is_msa_signed === false) {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          setTimeout(() => {
            window.$("#modalFormProfile").modal("hide");
            this.setState({ successMessage: "", errorMessage: "" });
          }, 2000);
        }
      } else if (
        apiResponse.data.status === 404 &&
        apiResponse.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try later.",
          disabled: false,
        });
        return false;
      } else {
        auth.clientLogout();
      }
    }
  };

  render() {
    const { currentStep } = this.state;

    const containerStyle = {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      width: "100%",
    };

    const isAgreementStep = this.state.stepsData?.[currentStep]?.type === "agreement";

    // Content fills remaining space below the fixed header + top stepper bar
    const contentStyle = {
      flex: 1,
      overflowY: isAgreementStep ? "visible" : "auto",
      background: "#fafbfc",
      minWidth: 0,
    };

    return (
      <>
        <div style={containerStyle}>
          {/* Client Header (fixed) */}
          <ClientHeader
            isOnboarding={true}
            currentStep={currentStep}
            modalOpen={() => this.profileView()}
            modalLogin={() => this.loginDetailView()}
            onToggleMobileStepper={this.handleToggleMobileSidebar}
          />

          {/*
           * TOP HORIZONTAL STEPPER BAR
           * Replaces the left sidebar. Same ref interface: refreshSteps / markStepCompleted.
           * marginTop: 70px pushes it flush below the fixed header.
           */}
          <div style={{ marginTop: "63px" }}>
            <OnboardingTopBar
              ref={this.sidebarRef}
              currentStep={currentStep}
              onStepChange={this.handleStepChange}
              clientAccountNo={this.state.clientAccountNo}
              userType={this.state.userType}
              onFormTokenChange={this.handleFormTokenChange}
              onFormChange={this.handleFormChange}
              onFormAccountChange={this.handleFormAccountChange}
              onAllowSkipChange={this.handleAllowSkipChange}
              onStepTitleChange={this.handleStepTitleChange}
              onStepsDataUpdate={this.handleStepsDataReceived}
              onOnboardingTitleChange={this.handleOnboardingTitleChange}
            />
          </div>

          {/* MAIN CONTENT — flows naturally below the top bar */}
          <div style={contentStyle} className="onboarding-content">
            <OnboardingContent
                currentStep={currentStep}
                onStepChange={this.handleStepChange}
                formToken={this.state.formToken}
                form={this.state.form}
                formAccountNo={this.state.formAccountNo}
                allowSkip={this.state.allowSkip}
                onSkipStep={this.handleSkipStep}
                stepsData={this.state.stepsData}
                clientAccountNo={this.state.clientAccountNo}
                onStepComplete={this.handleStepComplete}
                onOnboardingComplete={this.props.refreshStatus}
                stepTitle={this.state.stepTitle}
                isFormInReviewMode={this.isFormInReviewMode()}
                skipSuccessMessage={this.state.skipSuccessMessage}
                props={this.props}
                agreementData={this.state.stepsData[currentStep]}
                onboardingTitle={this.state.onboardingTitle}
                onboardingMessage={this.state.onboardingMessage}
              />
          </div>
        </div>

        {/* Modal for Profile Edit */}
        <div className="modal fade" tabIndex="-1" id="modalFormProfile">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <a
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  style={{ cursor: "pointer" }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
              </div>

              <div className="modal-body">
                {/* Error Alert */}
                {this.state.errorMessage && (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                  </div>
                )}
                {/* Success Alert */}
                {this.state.successMessage && (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row g-4">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="Company Name"
                        error={this.state.errorCompName}
                        id="comp_name"
                        name="comp_name"
                        value={this.state.comp_name}
                        placeholder="Company Name"
                        change={this.handleChange}
                        type="text"
                        maxLength={100}
                      />
                      <small className="form-text text-muted">
                        Allowed characters: ( _ . - , : &amp; ( ) | ! @ )
                      </small>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="Full Name"
                        error={this.state.errorName}
                        id="name"
                        name="name"
                        value={this.state.name}
                        placeholder="Full Name"
                        change={this.handleChange}
                      />
                      <small className="form-text text-muted">
                        Allowed characters: ( ' - . , : ( ) | ! @ )
                      </small>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="Title"
                        error={this.state.errorTitle}
                        id="title"
                        name="title"
                        value={this.state.title}
                        placeholder="Title"
                        change={this.handleChange}
                      />
                      <small className="form-text text-muted">
                        Allowed characters: ( _ - . &amp; , : ( ) | ! @ )
                      </small>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="Email"
                        type="text"
                        error={this.state.errorEmail}
                        id="email"
                        name="email"
                        value={this.state.email}
                        placeholder="Enter your email address"
                        change={this.handleChange}
                        disabled={true}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {!this.state.isLoading && (
                      <ReactPhoneInput
                        country="us"
                        inputProps={{
                          name: "phone",
                          id: "phone",
                          maxLength: 20,
                          required: true,
                          label: "Partner Phone Number",
                        }}
                        value={this.state.phone}
                        onChange={(value) =>
                          this.handleChange({
                            target: {
                              name: "phone",
                              value: `+${value}`,
                            },
                          })
                        }
                        specialLabel="Phone Number *"
                        containerStyle={{ width: "100%", marginTop: "30px" }}
                        inputStyle={{ width: "100%", height: "56px" }}
                        isValid={this.state.errorPhone !== "error"}
                      />

                    )}
                  </div>

                  <div
                    id="profileUpdate"
                    className="form-group col-md-4"
                    style={{ marginBottom: "0px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <label
                        htmlFor="googleLocation-autocomplete"
                        style={{
                          color: "black",
                          fontWeight: "500",
                        }}
                      >
                        Address
                      </label>
                      {this.state.address_autocomplete === "Yes" && (
                        <a
                          onClick={this.handleToggle}
                          style={{
                            cursor: "pointer",
                            fontSize: "11px",
                            color: "#0066cc",
                            textDecoration: "underline",
                          }}
                        >
                          {this.state.toggleButtonText}
                        </a>
                      )}
                    </div>
                    {this.state.address_autocomplete === "Yes" ? (
                      this.state.useGooglePlaces ? (
                        <GooglePlacesAutocomplete
                          apiKey={
                            process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                          }
                          selectProps={{
                            value: this.state.address
                              ? {
                                label: this.state.address,
                                value: this.state.address,
                              }
                              : null,
                            onChange: this.handleAddressSelect,
                            placeholder: this.state.address
                              ? null
                              : "Enter your address..",
                            styles: {
                              input: (provided) => ({
                                ...provided,
                                color: "black",
                                height: "35px",
                              }),
                              option: (provided) => ({
                                ...provided,
                                color: "black",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: "black",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9,
                              }),
                            },
                          }}
                          className="googleLocation-autocomplete"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          name="address"
                          value={this.state.address}
                          placeholder="Enter Po Box address"
                          onChange={this.handleChange}
                          style={{
                            borderColor: this.state.errorAddress
                              ? "red"
                              : "initial",
                            height: "45px",
                            border: "1px solid #dbdfea",
                            fontSize: "0.9375rem",
                          }}
                          maxLength={100}
                        />
                      )
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        value={this.state.address}
                        placeholder="Enter your address"
                        onChange={this.handleChange}
                        style={{
                          borderColor: this.state.errorAddress
                            ? "red"
                            : "initial",
                          height: "45px",
                          border: "1px solid #dbdfea",
                          fontSize: "0.9375rem",
                        }}
                      />
                    )}
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="Apartment, Suite, Etc."
                        type="text"
                        error={this.state.errorAddress2}
                        id="address2"
                        name="address2"
                        value={this.state.address2}
                        placeholder="Apartment, Suite, Etc."
                        change={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <TextField
                        label="City"
                        type="text"
                        error={this.state.errorCity}
                        id="city"
                        name="city"
                        value={this.state.city}
                        placeholder="Enter your city"
                        change={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="form-group">
                      <TextField
                        label="State"
                        type="text"
                        error={this.state.errorState}
                        id="states"
                        name="states"
                        value={this.state.states}
                        placeholder="State"
                        change={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="form-group">
                      <TextField
                        label="Zip Code"
                        type="text"
                        error={this.state.errorZip}
                        id="zip"
                        name="zip"
                        value={this.state.zip}
                        placeholder="Zip code"
                        change={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <Autocomplete
                        options={this.countryOptions}
                        getOptionLabel={(option) => option.label}
                        value={
                          this.state.country
                            ? {
                              label: this.state.country,
                              value: this.state.country,
                            }
                            : null
                        }
                        onChange={(event, newValue) => this.handleChangeCountry(newValue)}
                        renderInput={(params) => (
                          <MutextField
                            {...params}
                            required
                            placeholder="Select a country"
                            variant="outlined"
                            fullWidth
                            error={this.state.errorCountry === "error"}
                            helperText="Select country"
                          />
                        )}
                      />

                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div
                      className="form-group"
                      style={{ position: "relative" }}
                    >
                      <TextField
                        label={
                          <Tooltip
                            title="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                            placement="top"
                          >
                            <span>
                              <em
                                className="icon ni ni-info"
                                style={{ marginRight: 5 }}
                              ></em>
                              Password
                            </span>
                          </Tooltip>
                        }
                        type={this.state.passwordShown ? "text" : "password"}
                        error={this.state.errorPass}
                        id="password"
                        name="password"
                        value={this.state.password}
                        placeholder="Enter your password"
                        change={this.handleChange}
                      />
                      <a
                        style={{
                          left: "auto",
                          right: "2px",
                          top: "53px",
                          position: "absolute",
                          cursor: "pointer",
                        }}
                        tabIndex="-1"
                        onClick={this.togglePassword}
                        className="form-icon form-icon-right passcode-switch"
                      >
                        {this.state.passwordShown ? (
                          <em className="icon ni ni-eye-off"></em>
                        ) : (
                          <em className="icon ni ni-eye"></em>
                        )}
                      </a>
                      <PasswordStrengthBar password={this.state.password} />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div
                      className="form-group"
                      style={{ position: "relative" }}
                    >
                      <TextField
                        label={
                          <Tooltip
                            title="Confirm Password must match the Password."
                            placement="top"
                          >
                            <span>
                              <em
                                className="icon ni ni-info"
                                style={{ marginRight: 5 }}
                              ></em>
                              Confirm Password
                            </span>
                          </Tooltip>
                        }
                        type={
                          this.state.confirmPasswordShown ? "text" : "password"
                        }
                        error={this.state.errorConfirmPass}
                        id="confirm_password"
                        name="confirm_password"
                        value={this.state.confirm_password}
                        placeholder="Enter confirm password"
                        change={this.handleChange}
                      />
                      <a
                        style={{
                          left: "auto",
                          right: "2px",
                          top: "53px",
                          position: "absolute",
                          cursor: "pointer",
                        }}
                        tabIndex="-1"
                        onClick={this.toggleConfirmPassword}
                        className="form-icon form-icon-right passcode-switch"
                      >
                        {this.state.confirmPasswordShown ? (
                          <em className="icon ni ni-eye-off"></em>
                        ) : (
                          <em className="icon ni ni-eye"></em>
                        )}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-12 text-right">
                    <button
                      type="button"
                      className="btn btn-lg"
                      onClick={() => this.formUpdate()}
                      style={{
                        backgroundColor: "#1f3757",
                        color: "#fff",
                        float: "right",
                      }}
                      disabled={this.state.disabled}
                    >
                      Update Profile
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for Login Details */}
        <div
          className="modal fade"
          id="modalLoginDetail"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modalLoginDetailLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-xl modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modalLoginDetailLabel">
                  Login Details
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>IP Address</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Timezone</th>
                        <th>Login Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loginDetails &&
                        this.state.loginDetails.length > 0 ? (
                        this.state.loginDetails.map((detail, index) => (
                          <tr key={index}>
                            <td>{detail.ip_address}</td>
                            <td>{detail.country}</td>
                            <td>{detail.state}</td>
                            <td>{detail.city}</td>
                            <td>{detail.time_zone}</td>
                            <td>
                              {new Date(detail.login_time)
                                .toLocaleDateString("en-US", {
                                  month: "long",
                                  day: "numeric",
                                  year: "numeric",
                                })
                                .replace(/(\d+)(?=,)/, "$1th")}
                              ,{" "}
                              {new Date(detail.login_time).toLocaleTimeString(
                                "en-US",
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No login details found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        {/* <div style={footerWrapperStyle}>
          <ClientFooter />
        </div> */}
      </>
    );
  }
}

export default OnboardingDashboard;
